import { useTranslation } from "react-i18next";
import { PercentBadge } from "@/components/PercentBadge/PercentBadge";
import { useEvaluationPercentage } from "@/hooks/useEvaluationPercentage/useEvaluationPercentage";

import { EvaluationPercentageProps } from "./EvaluationPercentage.decl";

export function EvaluationPercentage({
  points,
  maximumPoints,
  disabled,
}: EvaluationPercentageProps) {
  const { t } = useTranslation();

  const { percentage } = useEvaluationPercentage({
    points: points ?? 0,
    maximumPoints,
  });

  if (disabled) {
    return (
      <p className="text-sm font-semibold text-muted-foreground">
        {t("not_applicable_full")}
      </p>
    );
  }

  // 0 is a valid value.
  if (points === undefined) {
    return;
  }

  if (points === null) {
    return <PercentBadge value={points} borderless />;
  }

  return (
    <div className="flex flex-col items-end gap-1">
      <PercentBadge value={percentage} borderless />
      <p className="text-tiny font-normal text-muted-foreground">
        {t("evaluation.question_summary_points", {
          text: `${points} / ${maximumPoints}`,
        })}
      </p>
    </div>
  );
}
